import {useRoute} from '@react-navigation/native';
import {Div, HeaderBack, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import RowButtonAction from '../DigitalSignature/RowButtonAction';

const DigitalSignatureChangeCMNDScreen = () => {
  const route = useRoute<any>();

  return (
    <Div backgroundColor={Ecolors.whiteColor} height={'100%'}>
      <HeaderBack type={2} title={`changecmnd.thaydoithongtin`} />
      <Div flex={1} alignItems="center" paddingTop={60} paddingHorizontal={60}>
        <ImageView
          widthHeight={85}
          source={Icons.signcmnd}
          resizeMode="contain"
        />
        <Label marginTop={38} textAlign="center">
          {'changecmnd.signcontent'}
        </Label>
      </Div>
      <RowButtonAction
        flowApp={route?.params?.flowApp}
        callback={file => {
          return route?.params?.callback && route?.params?.callback(file);
        }}
      />
    </Div>
  );
};

export default React.memo(DigitalSignatureChangeCMNDScreen);
